import React from 'react';
import { Form, Input, Button, Divider, Select, Image, Switch } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import SharedStyles from '../../sharedstyles';

// const [form] = Form.useForm();

class component extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.data !== state.data) {
            return {
                data: props.data
            };
        }
        return null;
    }

    render() {
        return (
            <div style={styles.container}>
                <Form
                    layout="vertical"
                    size="large"
                    requiredMark="optional"
                >
                    <Divider>Metadatas</Divider>
                    <Form.Item
                        required
                        label="CMS ID"
                        tooltip="The correlation id in CMS. Usually it is the post id of the wordpress post.">
                        <Input
                            allowClear
                            placeholder="Wordpress post id"
                            value={this.state.data["cms-id"]}
                            onChange={(event) => this.updateField("cms-id", event.target.value)} />
                    </Form.Item>
                    <Form.Item
                        required
                        label="Slug"
                        tooltip="Slug url of the blog post without slash.">
                        <Input
                            allowClear
                            placeholder="Slug"
                            value={this.state.data["slug"]}
                            onChange={(event) => this.updateField("slug", event.target.value)} />

                        <Button type="default" size="default" onClick={this.slugify.bind(this)}>Slugify</Button>
                    </Form.Item>
                    <Form.Item
                        required
                        label="Meta title tag"
                        tooltip="Meta title of the blog post. Keep less than 70 chars.">
                        <Input.TextArea
                            showCount
                            allowClear
                            placeholder="Meta title tag"
                            value={this.state.data["meta-title"]}
                            onChange={(event) => this.updateField("meta-title", event.target.value)}
                            autoSize />
                    </Form.Item>
                    <Form.Item
                        required
                        label="Meta description tag"
                        tooltip="Meta description of the blog post. Keep less than 160 chars."
                    >
                        <Input.TextArea
                            showCount
                            allowClear
                            placeholder="Meta description tag"
                            value={this.state.data["meta-description"]}
                            onChange={(event) => this.updateField("meta-description", event.target.value)}
                            autoSize />
                    </Form.Item>
                    <Form.Item
                        required
                        label="Anchor text"
                        tooltip="Optional anchor text for this page to be linked from other pages."
                    >
                        <Input.TextArea
                            showCount
                            allowClear
                            placeholder="Anchor text"
                            value={this.state.data["anchor"]}
                            onChange={(event) => this.updateField("anchor", event.target.value)}
                            autoSize />
                    </Form.Item>
                    <Divider>Blog</Divider>
                    <Form.Item
                        required
                        label="Title/H1"
                        tooltip="Title of the blog post"
                    >
                        <Input
                            allowClear
                            placeholder="Title"
                            value={this.state.data["title"]}
                            onChange={(event) => this.updateField("title", event.target.value)} />
                    </Form.Item>
                    <Form.Item
                        required
                        label="Subtitle"
                        tooltip="Subtitle of the blog post"
                    >
                        <Input.TextArea
                            allowClear
                            placeholder="Subtitle"
                            value={this.state.data["subtitle"]}
                            onChange={(event) => this.updateField("subtitle", event.target.value)}
                            autoSize />
                    </Form.Item>
                    <Form.Item
                        required
                        label="Hero image URL"
                        tooltip="Hero image url"
                    >
                        <Input
                            allowClear
                            placeholder="Hero image url"
                            value={this.state.data["hero-image-url"]}
                            onChange={(event) => this.updateField("hero-image-url", event.target.value)} />
                    </Form.Item>
                    {
                        this.state.data["hero-image-url"]
                            ? (
                                <Image
                                    width={200}
                                    height={100}
                                    src={this.state.data["hero-image-url"]}
                                    fallback="data:image/png;base64,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"
                                />
                            )
                            : null
                    }
                    <Divider>Misc.</Divider>
                    <Form.Item
                        required
                        label="Link sets"
                        tooltip="Links are grouped by sets. Select what links to be included."
                    >
                        <Select
                            mode="tags"
                            placeholder="Please select"
                            value={this.state.data["link-set"]}
                            onChange={(value) => this.updateField("link-set", value)}
                            style={{ width: '100%' }}
                        >
                            <Select.Option key="gatlinburg-tn-usa">gatlinburg-tn-usa</Select.Option>
                            <Select.Option key="pigeon-forge-tn-usa">pigeon-forge-tn-usa</Select.Option>
                            <Select.Option key="sevierville-tn-usa">sevierville-tn-usa</Select.Option>
                            <Select.Option key="smoky-mountain-tn-usa">smoky-mountain-tn-usa</Select.Option>
                            <Select.Option key="tennessee-usa">tennessee-usa</Select.Option>
                            <Select.Option key="wears-valley-tn-usa">wears-valley-tn-usa</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        required
                        label="Target site"
                        tooltip="Which site is this blog post for?"
                    >
                        <Select
                            placeholder="Please select"
                            value={this.state.data["target-site"]}
                            onChange={(value) => this.updateField("target-site", value)}
                            style={{ width: '100%' }}
                        >
                            <Select.Option key="smoky">smoky</Select.Option>
                            <Select.Option key="ukbnb">ukbnb</Select.Option>
                            <Select.Option key="en-us">vhr en-us</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        required
                        label="Page type"
                        tooltip="If this page only talk about a specific entity, choose entity page, otherwise choose content page."
                    >
                        <Select
                            placeholder="Please select"
                            value={this.state.data["page-type"]}
                            onChange={(value) => this.updateField("page-type", value)}
                            style={{ width: '100%' }}
                        >
                            <Select.Option key="content_page">Content Page</Select.Option>
                            <Select.Option key="entity_page">Entity Page</Select.Option>
                        </Select>
                    </Form.Item>

                    {
                        this.state.data["page-type"] == "entity_page"
                            ? (
                                <>
                                    <Form.Item
                                        required
                                        label="Call to action link"
                                        tooltip="Highlighted call-to-action link button for this entity."
                                    >
                                        <Input
                                            allowClear
                                            placeholder="Call to action url"
                                            value={this.state.data["call-to-action-url"]}
                                            onChange={(event) => this.updateField("call-to-action-url", event.target.value)} />
                                    </Form.Item>
                                    <Form.Item
                                        required
                                        label="DO FOLLOW"
                                        tooltip="Default page is enabled. If this page is not ready to be generated, turn it off."
                                    >
                                        <Switch
                                            checked={this.state.data["do-follow"] ?? true}
                                            onChange={(value) => this.updateField("do-follow", value)}
                                        />
                                    </Form.Item>
                                </>
                            )
                            : null
                    }

                    <Form.Item
                        required
                        label="Parent page(s)"
                        tooltip="Specify parent page that this page should be linked from."
                    >
                        <Select
                            mode="tags"
                            placeholder="Please select"
                            value={this.state.data["parent-pages"]}
                            onChange={(value) => this.updateField("parent-pages", value)}
                            style={{ width: '100%' }}
                        >
                            {this.getParentOptions()}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        required
                        label="Optional page tags"
                        tooltip="Tags that helps you find this page. Select 'Home Page' if this post needs to be featured on home page."
                    >
                        <Select
                            mode="tags"
                            placeholder="Optionally specify some tags"
                            value={this.state.data["tags"]}
                            onChange={(value) => this.updateField("tags", value)}
                            style={{ width: '100%' }}
                        >
                            <Select.Option key="home-page">Home Page</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        required
                        label="Page enabled?"
                        tooltip="Default page is enabled. If this page is not ready to be generated, turn it off."
                    >
                        <Switch
                            checked={this.state.data["isEnabled"] ?? true}
                            onChange={(value) => this.updateField("isEnabled", value)}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" onClick={this.onSave.bind(this)}>Save</Button>
                    </Form.Item>
                </Form>
            </div>
        )
    }
    getParentOptions() {
        var options = [];
        var rankedPosts = this.rankedBlogPostsByTags();
        for (var i = 0; i < rankedPosts.length; i++) {
            var post = rankedPosts[i];
            var slug = post.slug;

            if (this.state.data.slug != slug) {

                // Prepend some page tags before the options to make it easier to find.
                var tags = [];
                if (post["page-type"] == "content_page") {
                    tags.push(<span style={styles.pageTagBlue}>CONTENT</span>)
                }
                else if (post["page-type"] == "entity_page") {
                    tags.push(<span style={styles.pageTagGrey}>ENTITY</span>)
                }

                if (post.tags) {
                    for (var j = 0; j < post.tags.length; j++) {
                        tags.push(<span style={styles.pageTagGreen}>{post.tags[j]}</span>)
                    }
                }

                options.push(
                    <Select.Option key={post._id}>{tags}{slug}</Select.Option>
                )
            }
        }

        return options;
    }

    rankedBlogPostsByTags() {
        var ranked = JSON.parse(JSON.stringify(this.props.blogPosts));

        ranked.sort(function (a, b) {
            if (!a.tags && b.tags) {
                return 1;
            }
            else if (a.tags && !b.tags) {
                return -1;
            }
            else if (!a.tags && !b.tags) {
                return 0;
            }

            var aTags = a.tags.join('');
            var bTags = b.tags.join('');

            return aTags.localeCompare(bTags)
        })

        return ranked;
    }

    updateField(fieldName, value) {
        var copy = this.state.data;
        copy[fieldName] = value;
        this.setState({
            data: copy
        })
    }

    handleLinkSetSelectionChange(value) {
        this.setState({
            selectedLinkSets: value
        })
        console.log(value)
    }

    slugify() {
        var original = this.state.data.slug;

        var slug = original.replace(/^\s+|\s+$/g, ''); // trim
        slug = slug.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to = "aaaaeeeeiiiioooouuuunc------";
        for (var i = 0, l = from.length; i < l; i++) {
            slug = slug.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        slug = slug.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

        this.updateField("slug", slug);
    }

    onSave() {
        this.props.onSave(this.state.data)
    }
}

var styles = {
    container: {
        height: '100%',
        padding: `10px ${SharedStyles.horizontalSpacing}px`,
        overflowY: 'scroll',
    },
    pageTagBlue: {
        backgroundColor: '#002FA7',
        color: 'white',
        marginRight: 4,
        borderRadius: 2,
        padding: '1px 2px',
        fontSize: 11,
        fontWeight: '500',
    },
    pageTagGrey: {
        backgroundColor: '#777777',
        color: 'white',
        marginRight: 4,
        borderRadius: 2,
        padding: '1px 2px',
        fontSize: 11,
        fontWeight: '500',
    },
    pageTagGreen: {
        backgroundColor: '#55BA86',
        color: 'white',
        marginRight: 4,
        borderRadius: 2,
        padding: '1px 2px',
        fontSize: 11,
        fontWeight: '500',
    }
}

export default component;